module.exports = __webpack_public_path__ + "static/media/sosna.257206eb.jpg";